import { action }                from 'mobx';
import { makeObservable }        from 'mobx';
import { observable }            from 'mobx';
import { reaction }              from 'mobx';
import { Shape }                 from '@tokamap/core';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';
import { loadCurrentDocuments }  from '@/TokamapEditor/stores/PreviewMapsStore';
import { pairMapsWithDocuments } from '@/TokamapEditor/stores/pairMapsWithDocuments';

/**
 * Formes enregistrées des AUTRES cartes du projet (la carte ouverte se compte en direct). Rechargé au
 * changement de carte et à chaque modification d'une autre carte.
 */
class ProjectShapesStore {
	@observable.ref private _shapesByMapId: Record<string, Shape[]> = {};

	// Une réponse arrivée après une requête plus récente ne doit pas l'écraser.
	private _loadId = 0;

	constructor() {
		makeObservable(this);

		reaction(
			() => {
				const projectEditor = currentProjectEditorStore.get;
				const currentMapUrn = projectEditor.currentMap.urn;
				const otherModifications: string[] = [];

				projectEditor.lastModificationByMapUrn.forEach(modification => {
					if (modification.mapUrn !== currentMapUrn) {
						otherModifications.push(`${modification.mapUrn}@${modification.at.getTime()}`);
					}
				});

				return [projectEditor.project.id, projectEditor.currentMap.id, otherModifications.sort().join(',')].join('|');
			},
			() => void this.load(),
			{ delay: 500, fireImmediately: true },
		);
	}

	/** Formes enregistrées d'une carte — vide tant que les documents ne sont pas chargés. */
	shapesOfMap(mapId: id): Shape[] {
		return this._shapesByMapId[String(mapId)] || [];
	}

	async load() {
		const projectEditor = currentProjectEditorStore.get;
		const loadId = ++this._loadId;

		if (!projectEditor.project.id || projectEditor.mapCollection.length < 2) {
			return this._set({});
		}

		try {
			const documents = await loadCurrentDocuments();
			const maps = pairMapsWithDocuments(projectEditor.mapCollection.models, documents.maps);

			if (loadId !== this._loadId) return;

			this._set(Object.fromEntries(maps.map(map => [String(map.mapId), map.shapes])));
		} catch (err) {
			console.error('Formes des cartes du projet', err);
		}
	}

	@action private _set(shapesByMapId: Record<string, Shape[]>) {
		this._shapesByMapId = shapesByMapId;
	}
}

export default new ProjectShapesStore();
